<template>
  <div class="gf-field-checkbox">
    <input v-model="componentValue" type="checkbox" value="1" />
  </div>
</template>

<script>
import { componentMixin } from './FormCommon'

export default {
  props: ["placeholder", "type"],
  mixins: [componentMixin],
}
</script>
